import { twMerge } from 'tailwind-merge'

export default function Skeleton({
  className='',
  ...props
}) {
  return (
    <div
      className={twMerge('animate-pulse rounded-md bg-pebble-100', className)}
      {...props}
    />
  )
}
